import router from '~/core/router';
import { OnboardingRoute } from '~/modules/onboarding-new';

router.addPrivateRoutes([OnboardingRoute]);
